import { createSelector } from '@app/utils/createSelector'
import { catchFetchDataError } from '@app/utils/performFetchData'

import type { ApiQuizGame } from '@app/packages/api/v2/types/entities'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

export type QuizGame = { id: ApiQuizGame['id'] } & ApiQuizGame['attributes']

const quizSlice = createReduxSlice<QuizGame[]>('quiz')

export const fetchQuizGames = () =>
  createThunk(async dispatch => {
    const [{ getQuizGames }, { callV2Api }] = await Promise.all([import('@app/packages/api/v2/actions/quiz'), import('@app/store/actions/api')])
    const resp = await dispatch(callV2Api(getQuizGames())).catch(catchFetchDataError(dispatch, 'Quiz data fetch failed'))
    dispatch(quizSlice.set(resp.data.map(convert)))
  })

export const quizGamesSelector = createSelector([quizSlice.selector], games => games ?? [])

const convert = (game: ApiQuizGame): QuizGame => {
  return { id: game.id, ...game.attributes }
}
